import React from "react";
import styled from "styled-components";
import SignupBox from "./Signup/SignupBox/SingupBox";
import SignupInfo from "./Signup/SignupInfo/SignupInfo";

const Root = styled.div`
  margin: 0 auto;
`;

const Wrapper = styled.div`
  padding-top: 150px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileL}) {
    padding-top: 110px;
  }
`;

const Container = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  @media (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    flex-direction: column;
  }
`;

const Row = styled.div`
padding-bottom: 80px;
@media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
  display: flex;
  justify-content: flex-start;
}
`;

const Join = () => {

  return (
    <Root>
      <Wrapper>
        <Container className="main-container">
          <Row>
            <SignupInfo />
          </Row>
          <Row>
            <SignupBox />
          </Row>
        </Container>
      </Wrapper>
    </Root>
  );
};

export default Join;
